import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import { sparklineChartV2 } from '../../directives/sparklineChartsV2';

import template from './countVerticalv2.tpl.html';
import  {
  Counts,
  LineCounts,
  LineEquipmentItem,
  LineItem,
  LineJunctionItem,
  LineEquipmentDetail,
  LineEquipmentGroup,

  LineEquipmentDataPoint,
  LineEquipmentCounts,
  LineEquipmentRow,
  Count
} from "../../models/counts/lineCounts";

import { Plant } from "../../models/navigation";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsEnums } from "../../shared/dto/aps.enums";
import { States } from "../../shared/config/constant.module";
import { apsDisplayEnums } from "../../shared/dto/enums";
import { StateParams } from "../../common";

import CountsServiceName, { CountHub, CountsService } from "../../services/counts/counts.service";
import UIUtilityServiceName, { EnumOption, UIUtilityService } from "../../services/utility/uiUtility.service";
import LineConfigsServiceName, { LineConfigsService } from "../../services/lineConfigs/lineConfigs.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import GroupRejectsServiceName, { GroupRejectsService } from "../../services/counts/groupRejects.service";
import DataPointServiceName, { DataPointService } from '../../services/dataPoints/dataPoints.service';

import * as Highcharts from 'highcharts/highstock';
import { IInterval, Interval } from '../../directives/interval.factory';
import countsHeader from './counts.header.directive';
import { IBtn, IBtnArrayOptions } from '../dashboard/btnarray.interfaces';
import '../../shared/polyfill';

import IPromise = angular.IPromise;
import IStateService = angular.ui.IStateService;
import IScope = angular.IScope;
import IIntervalService = angular.IIntervalService;
import IQService = angular.IQService;
import { ICountControllerBase, lineCountsLoaded, usePercentGobsProducedChanged } from './count.controller';

const requires = [CountsServiceName, UIUtilityServiceName, LineConfigsServiceName, LoaderServiceName,
  NavigationServiceName, AuthDataServiceName, GroupRejectsServiceName, countsHeader, DataPointServiceName
];

const validate = function (i) {
  return i !== null && angular.isDefined(i);
};

export interface CountVerticalControllerInterface extends ICountControllerBase {
  $stateParams: StateParams;
  $state: IStateService;
  interval: IInterval;
  areas: CountAreaInterface[];
  plant: Plant;
  shop: apsViewModels.ShopNavigation;
  hub: CountHub;
  updatedModel: LineCounts;
  updatedAreas: CountAreaInterface[];
  countDisplayIntervalOptions: EnumOption[];
  countsInterval: apsDisplayEnums.CountDisplayInterval;
  canDisableLine: boolean;
  cavities: apsViewModels.CavityCountSummary[];
  hasCavities: boolean;
  detailChartConfig: any;
  showCharts: boolean;

  navigationUrls: IBtnArrayOptions;
  viewRejectDetail(line: LineItem, equipment: LineEquipmentItem): void;
  viewGroupRejectDetail(equipmentGroup: LineEquipmentGroup): void;
  countsIntervalChanged(): void;
  calculateSpeed(gobsCount: Counts): number;
  toggleLineActive(line: LineItem): void;
  showHelp(helpScreen: string): void;
  toggleHelpWindow(): void;
	showHelpWindow: boolean;
	helpText: string;
  requests: object;
  vc: Array<VertCtDevice>;
  parents: VertCtRequest;
  children: VertCtRequest;
}

interface CountRowInterface {
  isLine: boolean;
  line: LineItem;
  junction: LineJunctionItem;
  cssClass: string;
}

interface CountAreaInterface {
  rows: CountRowInterface[];
}

export interface RejectTolerances {
  rejectMinPercentage: number;
  rejectMaxPercentage: number;
}

class VertCtRequest {
  dataPoints: Array<VertCtDataPointHistoryReportItem>;
  hash: object;
}

class VertCtPercent {
  error: boolean;
  value: string;
}

class VertCtTrend {
  flat: boolean;
}

class VertCt {
  id: string;
  name: string;
  number: number;
  state: string;
}

class VertCtRejectCount {
  id: string;
  count: number;
  name: string;
  percent: VertCtPercent;
  trend: VertCtTrend;
  trendCounts: number[];
}

class VertCtRejectChildCount {
  id: string[];
  count: number;
  name: string;
  percent: VertCtPercent;
  trend: VertCtTrend;
  trendCounts: number[];
}

class VertCtInspectCount {
  count: number;
}

class VertCtEquipment {
  id: string;
  name: string;
  inspectCount: VertCtInspectCount;
  line: VertCt;
  rejectCount: VertCtRejectCount;
  rejectMaxPercentage?: number;
  rejectMinPercentage?: number;
}

class VertCtChildEquipment {
  id: string;
  name: string;
  inspectCount: VertCtInspectCount;
  line: VertCt;
  rejectCount: VertCtRejectChildCount;
}

class VertCtDevice {
  id: string;
  name: string;
  equipment: VertCtEquipment[];
  children: VertCtDevice[];
  constructor(id: string, name: string, equipment: VertCtEquipment[]) {
    this.id = id;
    this.name = name;
    this.equipment = equipment;
  }
}

class VertCtChildDevice {
  id: string;
  name: string;
  equipment: VertCtChildEquipment[];
  children: VertCtDevice[];
  constructor(id: string, name: string, equipment: VertCtChildEquipment[]) {
    this.id = id;
    this.name = name;
    this.equipment = equipment;
  }
}

class VertCtDataPointHistoryRequest {
  dataPointId: string;
  countInterval: apsEnums.CountInterval;
  start: Date;
  end: Date;
  type: string;
  eq: VertCtEquipment;
}

class VertCtDatapointListRequest {
  plantLocationId: string;
  shopId: string;
  datapointIds: string[];
  startDate: Date;
  endDate: Date;
  countInterval: apsEnums.CountInterval;
  type: string;
  eq: VertCtEquipment;
}

class VertCtDatapointListReportItem {
  request: VertCtDatapointListRequest;
  result: number[];
}

class VertCtDataPointHistoryReportItem {
  request: VertCtDataPointHistoryRequest;
  result: number[];
  constructor() {
    this.request = new VertCtDataPointHistoryRequest();
  }
}

export interface CountsVerticalCtrlV2ModelScopeInterface extends IScope {
  count: any;
}

export class CountsVerticalCtrlV2 implements ICountControllerBase {
  $scope: CountsVerticalCtrlV2ModelScopeInterface;
  $modal: mm.foundation.modal;
  $state: IStateService;
  $interval: IIntervalService;
  $q: IQService;

  $stateParams: StateParams;
  countsService: CountsService;
  lineConfigsService: LineConfigsService;
  loaderService: LoaderService;
  navigationService: NavigationService;
  authDataService: AuthDataService;
  groupRejectsService: GroupRejectsService;
  uiUtilityService: UIUtilityService;
  dataPointService: DataPointService;
  hasCavities: boolean;
  showHelpWindow: boolean;
  helpText: string;

  model: LineCounts;
  plant: Plant;

  canDisableLine: boolean;

  countsInterval: apsDisplayEnums.CountDisplayInterval;
  countsPromise: any;
  areas: CountAreaInterface[];
  updatedAreas: CountAreaInterface[];

  shopId: string;
  shop: apsViewModels.ShopNavigation;

  requests: object;
  vc: VertCtDevice[] = [];

  interval: Interval;

  countDisplayIntervalOptions: EnumOption[];
  detailChartConfig: any;
  showCharts: boolean = true;

  navigationUrls: any;

  lossPercentClass: any;
  equipmentRejectTolerances = {};
  blinkClass =  " blinkingVerticals";

  parents: VertCtRequest;
  children: VertCtRequest;

  constructor(
    $stateParams: StateParams,
    $q: IQService,
    $scope: CountsVerticalCtrlV2ModelScopeInterface,
    $modal: mm.foundation.modal,
    $state: IStateService,
    $interval: IIntervalService,
    countsService: CountsService,
    lineConfigsService: LineConfigsService,
    loaderService: LoaderService,
    navigationService: NavigationService,
    authDataService: AuthDataService,
    groupRejectsService: GroupRejectsService,
    uiUtilityService: UIUtilityService,
    dataPointService: DataPointService
  ) {

    this.$scope = $scope;
    this.$modal = $modal;
    this.$state = $state;
    this.$interval = $interval;
    this.$q = $q;

    this.countDisplayIntervalOptions = uiUtilityService.getListOptionsFromEnum(apsDisplayEnums.CountDisplayInterval, null, null, o => o);
    this.countsInterval = authDataService.getCountInterval();
    this.detailChartConfig = this.getDetailsChartConfig();
 
    this.$stateParams = $stateParams;
    this.countsService = countsService;
    this.lineConfigsService = lineConfigsService;
    this.loaderService = loaderService;
    this.navigationService = navigationService;
    this.authDataService = authDataService;
    this.groupRejectsService = groupRejectsService;
    this.dataPointService = dataPointService;
    this.uiUtilityService = uiUtilityService;
    this.helpText = null;

    this.shopId = this.$stateParams.shopId;

    this.navigationUrls = {
			buttons: [
				{ 'name': 'Horizontal Layout', 'value': 'horizontal', 'selected': false },
				{ 'name': 'Vertical Layout', 'value': 'vertical', 'selected': false },
				{ 'name': 'Vertical Layout (v2)', 'value': 'vc2', 'selected': true },
			],
			select: (button: IBtn) => {
				let stateParams = {
					plantId: $stateParams.plantId,
					shopId: $stateParams.shopId,
					userId: $stateParams.userId,
        };

				switch (button.value) {
					case "horizontal": $state.go(States.COUNTS_HORIZONTAL, stateParams); break;
					case "vertical": $state.go(States.COUNTS_VERTICAL, stateParams); break;
					case "vc2": $state.go(States.COUNTS_VERTICAL_V2, stateParams); break;
				}
			}
    };

    this.canDisableLine = authDataService.isPlantOrAPSIOAdminForCurrentPlant();



    let updateBlinkClass = () => {
      if (this.blinkClass.indexOf("light") > 0) {
        this.blinkClass = " blink-dark-vert";
      } else {
        this.blinkClass = " blink-light-vert";
      }
    }
  
    var blinkTimer: angular.IPromise<any>;
    let createBlinkTimer = () => {
      updateBlinkClass();
      if (blinkTimer) {
        $interval.cancel(blinkTimer);
      }
      blinkTimer = $interval(updateBlinkClass, 600);
    }
  
    $scope.$on("$destroy", function() {
          if (blinkTimer) {
              $interval.cancel(blinkTimer);
          }
      });

    let updateFunc = () =>{
      this.update();
    }

    this.countsPromise = this.setupNavigationPromise();
      
    const promise =  this.countsPromise.then(() => {
      createBlinkTimer();
      this.interval = new Interval(updateFunc, this.$interval, 5 * 60 * 1000); // 5 mintues
      this.interval.start();

      $scope.$on('$destroy', () => {
        if (this.interval != null) {
          this.interval.destroy();
        this.interval = null;
        }
      });
    });

  loaderService.loadingPromise(promise);
}
  usePercentGobsChanged(): void {
    this.model.usePercentGobs = !this.model.usePercentGobs;
    usePercentGobsProducedChanged(this.countsService, this.plant.id, this.model.usePercentGobs);
    this.lineCountsHandler(this.model);
  }

  mapToNewFormat(mappedResult): VertCtDevice[] {
    let o = {};
    mappedResult.forEach(x => {
      let device = o[x.name] as VertCtDevice;
      if (angular.isUndefined(device)) {
        device = new VertCtDevice(x.id, x.name, []);
      }
      o[x.name] = device;
      let equipment = {
        line: {
          name: x.lineName,
          id: x.lineId,
          number: x.lineNumber,
          state: 'normal' // todo: normal | error
        } as VertCt,
        id: x.id,
        name: x.name,
        inspectCount: {
          count: x.count
        } as VertCtInspectCount,
        rejectCount: {
          id: x.rejectCount ? x.rejectCount.id : "",
          name: x.rejectCount ? x.rejectCount.name : "",
          count: x.rejectCount ? x.rejectCount.count : 0,
          percent: {
            value: (x.rejectCount ? x.rejectCount.percent : 0) + '%',
            error: false, // todo: calculate
          } as VertCtPercent,
          trendCounts: [0], //x.rejectCount ? x.rejectCount.trendCounts : [0, 0, 0, 0],
          trend: x.rejectCount ? x.rejectCount.trend : { flat: true }
        } as VertCtRejectCount
      } as VertCtEquipment;
      device.equipment.push(equipment);
    });
    var result = Object.keys(o).map(key => o[key] as VertCtDevice);
    return result;
  }

  mapLineToRow(line: LineItem): CountRowInterface {
    return {
      isLine: true,
      line: line,
      junction: null,
      cssClass: null
    };
  }

  mapJunctionToRow(junction: LineJunctionItem): CountRowInterface {
    return {
      isLine: false,
      line: null,
      junction: junction,
      cssClass: 'table' + (junction.inputs.length > junction.outputs.length
        ? junction.inputs.length : junction.outputs.length).toString()
    };
  }

  mapModelToAreas(model: LineCounts): CountAreaInterface[] {
    const areas = [];

    // filter by startJunctionId, sort by number

    let area: CountAreaInterface = {
      rows: _.sortBy(model.lines.filter(l => l.startJunctionId === null), r => r.number)
        .map(l => this.mapLineToRow(l))
    };

    while (area.rows.length > 0) {
      areas.push(area);

      const previousLines = area.rows.filter(l => l.isLine).map(l => l.line);
      const rows = [];
      area.rows.forEach(row => {
        // if row is junction, add all of the output lines
        if (!row.isLine) {
          _.sortBy(row.junction.outputs, l => l.number).forEach(line => {
            rows.push(this.mapLineToRow(line));
          });
          return;
        }

        const junction = row.line.endJunction;
        if (!junction) {
          return;
        }

        // do not add the junction if it is already in the list of rows
        if (_.some(rows, r => !r.isLine && r.junction === junction)) {
          return;
        }

        // if the end junction references lines not in the previous area, add the line instead
        if (!junction.inputs.every(l => _.some(previousLines, al => al.id === l.id))) {
          rows.push(this.mapLineToRow(row.line));
        }

        rows.push(this.mapJunctionToRow(junction));
      });

      area = { rows: rows };
    }
    return areas;
  }

  mapRejectCount(rc: Count, id: string, name: string) {
    if (rc) {
      return {
        type: "rejectCount",
        id: id,
        name: name,
        count: rc.count,
        percent: rc.percent ? rc.getPercent() : '0',
        trendCounts: [0], //rc.trendCounts ? rc.trendCounts : [0, 0, 0, 0],
        trend: rc.trend ? rc.trend : { flat: true }
      };
    } else {
      return null;
    }
  }

  mapLine(line: LineItem) {
    return {
      type: "line",
      name: line.name,
      id: line.id,
      shopId: line.shopId,
      number: 1,
      equipment: line.equipment ? line.equipment.filter(validate).map(e => {
        var ic = e.inspectCount;
        return {
          lineId: line.id,
          lineName: line.name,
          lineNumber: line.number,
          type: "equipment",
          id: e.id,
          name: e.name,
          order: e.order,
          count: ic.count,
          trend: ic.trend,
          trendCounts: [0], // ic.trendCounts,
          rejectCount: ic.rejectCounts ? this.mapRejectCount(ic.rejectCounts.filter(validate)[0], e.rejectDataPointId, e.rejectDataPointName) : null
        };
      }) : [],
    };
  }

  update() {

    if (this) {

      this.countsPromise = this.setupNavigationPromise();

      this.loaderService.loadingPromise(this.countsPromise);

      if (this.model) {
        this.model.handleIntervalChange(this.countsInterval);
      }
      this.authDataService.setCountInterval(this.countsInterval);
    }
  }


  // create a hash and vc count
  lineCountsHandler(result: LineCounts) {
    this.model = result;
    lineCountsLoaded(this);
    try {
      const mappedResult = [];
      result.lines
        .filter(validate)
        .forEach(line => {
          var l = this.mapLine(line);
          l.equipment.forEach(e => mappedResult.push(e));
        });

      this.vc = this.mapToNewFormat(mappedResult);

      this.parents = {
        dataPoints: new Array<VertCtDataPointHistoryReportItem>(),
        hash: {}
      };

      // separater collection for children
      this.children = {
        dataPoints: new Array<VertCtDataPointHistoryReportItem>(),
        hash: {}
      };

      // create hash from verticalcounts
      _.forEach(this.vc, line => {
        _.forEach(line.equipment, eq => {
          if (angular.isDefined(eq.rejectCount.id)) {
            this.parents.hash[eq.rejectCount.id] = eq;
          }
        });

        // add to children hash
        _.forEach(line.children, child => {
          _.forEach(child.equipment, eq => {
            if (angular.isDefined(eq.id)) {
              this.children.hash[eq.id] = eq;
            }
          })
        });
      });

      console.log('vc', this.vc);
    } catch (e) {
      console.log('unexpected error', e);
    }

    this.areas = this.mapModelToAreas(this.model);

    let rejects = this.model.shopConfig.jobRuns[0].machineRejectPercentages;
    if (!!rejects) { 
      this.areas.forEach(area => {
        area.rows.forEach(row => {
          if (!row.isLine) { return; }
          row.line.equipment.forEach(equipment => {
            let equipWithRejectPercentage = rejects.filter(item => item.selectedMachine === equipment.name );
            if (equipWithRejectPercentage.length > 0) {
              let tolerances: RejectTolerances = {
                rejectMinPercentage: equipWithRejectPercentage[0].rejectedMinPercentage,
                rejectMaxPercentage: equipWithRejectPercentage[0].rejectedMaxPercentage
              };
              this.equipmentRejectTolerances[equipment.name] = tolerances;
            }
          });
        });
      });
    }

    for (let id in this.model.equipment) {
      if (this.model.equipment[id].type === apsEnums.LineEquipmentType.HEYE
        || this.model.equipment[id].type === apsEnums.LineEquipmentType.CheckDetector
        || this.model.equipment[id].type === apsEnums.LineEquipmentType.MX4
        || this.model.equipment[id].type === apsEnums.LineEquipmentType.Mcal
        || this.model.equipment[id].type === apsEnums.LineEquipmentType.Multi
      ) {
        this.hasCavities = true;
        break;
      }
    }
  }

  populatePlantAndShopHandler(navModel) {
    this.plant = navModel.selectedPlant;
    this.shop = navModel.selectedShop;
  }

  getLineCountsPromise(): IPromise<any> {
    return this.executePromise(() => {

      let countsByShears = true;

      console.log("getLineCounts(shopId:" + this.shopId + ", plant:" + this.plant + ", countsInterval:" + this.countsInterval + ")")
      //return this.countsService.getLineCounts(this.shopId, this.plant, this.countsInterval, this.canDisableLine)
      return this.countsService.getLineCounts(this.shopId, this.plant, this.countsInterval, this.canDisableLine, false, countsByShears)
        .then((data) => this.lineCountsHandler(data))
        .then(() => this.getDetailCounts())
        .then(() => this.getParentTrendCounts())
        // .then(() => this.getChildrenTrendCounts())
        .catch((reason) => {
          console.log("failed getLineCountsPromise: ", reason);
        });
    }, "getLineCounts");
  }

  setupNavigationPromise(): IPromise<any> {
    return this.navigationService.getNavigation()
      .then((data) => this.populatePlantAndShopHandler(data))
      .then(() => this.getLineCountsPromise())
      .catch((reason) => {
        console.log("failed getnavigation: ", reason);
      });
  }

  execute(method: () => any, info: string): any {
    console.log('started ' + info + '...');
    try {
      var result = method();
      console.log('completed ' + info + '.');
      return result;
    }
    catch {
      console.log('failed ' + info + '.');
    }
  }

  executePromise(method: () => IPromise<any>, info: string): any {
    console.log('started ' + info + '...');
    return method()
      .finally(() => {
        console.log('completed ' + info + '.');
      }).catch(reason => {
        console.log('failed ' + info + '.  ' + reason);
      });
  }

  createChildFromTabCell(line: LineItem, o: LineEquipmentRow) {
    const count = o.cells[0].count;
    return {
      line: {
        id: line.id,
        name: line.name,
        number: 0,
        state: 'normal'
      } as VertCt,
      id: count.cells[0].dataPointIds,
      name: o.displayName,
      inspectCount: {
        count: null
      } as VertCtInspectCount,
      rejectCount: {
        id: null,
        name: null,
        count: count.count,
        percent: {
          value: count.getPercent(),
          error: false,
        } as VertCtPercent,
        trendCounts: [0], // count.trendCounts,
        trend: count.showTrend ? count.trend : null
      } as VertCtRejectCount,
    };
  }

  createChildFromDetail(line, o: LineEquipmentDataPoint) {
    const count = o.count;
    return {
      line: {
        id: line.id,
        name: line.name,
        number: 0,
        state: 'normal'
      } as VertCt,
      id: "",
      name: "",
      inspectCount: {
        count: null
      } as VertCtInspectCount,
      rejectCount: {
        id: "",
        name: "",
        count: count.count,
        percent: {
          value: count.getPercent(),
          error: false,
        } as VertCtPercent,
        trendCounts: [0], // o.count.trendCounts,
        trend: count.showTrend ? count.trend : null
      } as VertCtRejectCount,
    };
  }

  detailCountsHandler(counts: LineEquipmentCounts, equip: LineEquipmentItem) {
    const request = this.requests[equip.id];

    request.result = counts;

    var eq = counts.equipment;
    var line = counts.equipment.line;

    var subEquipment = {
      equipment: {
        id: eq.id,
        name: eq.name,
      },
      line: {
        id: line.id,
        name: line.name
      },
      children: angular.isDefined(counts.tabs[0]) && angular.isDefined(counts.tabs[0].outputRows)
        ? counts.tabs[0].rows.map((o) => this.createChildFromTabCell(line, o))
        : (counts.details != null ? counts.details.map((o) => this.createChildFromDetail(line, o)) : []
        )
    };

    request.test = subEquipment;

    var device: any = _.find(this.vc, (e) => {
      return e.name === subEquipment.equipment.name;
    });

    if (angular.isDefined(device)) {
      _.forEach(subEquipment.children, (child) => {
        // initialize device children if not initialized
        if (!angular.isDefined(device.children)) {
          device.children = [];
        }
        var cg: any = _.find(device.children, (c: any) => {
          return c.name === child.name;
        });
        // if not found, then create a new childgroup
        if (angular.isUndefined(cg)) {
          // create a new child group
          cg = {
            name: child.name,
            id: child.id,
            equipment: []
          } as VertCtDevice;
          // add child group to the device found
          device.children.push(cg);
        }
        cg.equipment.push(child);
      });
    }
  }

  getDetailCounts() {
    const promises = [];

    _.forEach(this.updatedAreas, updatedArea => {
      _.forEach(updatedArea.rows, updatedRow => {
        if (updatedRow.line === null) {
          return;
        }
        _.forEach(updatedRow.line.equipment, updatedEquip => {
          _.forEach(this.areas, area => {
            _.forEach(area.rows, row => {
              if (row.line === null) {
                return;
              }
              _.forEach(row.line.equipment, equip => {
                if (equip.id === updatedEquip.id) {
                  equip.inspectCount.count = updatedEquip.inspectCount.count;

                  if (updatedEquip.rejectCount != null) {
                    equip.rejectCount.count = updatedEquip.rejectCount.count;
                    equip.rejectCount.percent = updatedEquip.rejectCount.percent;
                    equip.rejectCount.gobPercent = updatedEquip.rejectCount.gobPercent;
                  }
                  if (!angular.isDefined(equip.inspectCount)
                    && !angular.isDefined(equip.rejectCount)
                    && !angular.isDefined(equip.inspectCount.count)
                    && !angular.isDefined(equip.rejectCount.count)) {
                    if (equip.inspectCount.count === 0 && equip.rejectCount.count === 0) {
                      let resetLineEquipDetail: LineEquipmentDetail[] = [];
                      equip.lineEquipmentDetail = resetLineEquipDetail;
                    }
                  }
                }
              });
            });
          });
        });
      });
    });

    // get data for each reject parent id
    this.requests = {};

    _.forEach(this.areas, area => {
      _.forEach(area.rows, row => {
        if (row.line === null) {
          return;
        }

        _.forEach(row.line.equipment, equip => {

          this.requests[equip.id] = {
            request: {
              shopId: this.shopId,
              equipmentId: equip.id,
            },
            result: {}
          };

          let promise = this.countsService.getEquipmentCounts(this.shopId, this.model, equip, this.countsInterval)
            .then((counts) => this.detailCountsHandler(counts, equip));

          promises.push(promise);

        });
      });
    });

    return this.$q
      .all(promises)
      .then(() => {
        console.log("getDetailsCounts finished.");
      })
      .catch(reason => {
        console.log('error:', reason);
      });
  }

  toggleLineActive(line: LineItem) {
    if (!this.canDisableLine) {
      return;
    }

    let message = `Line ${line.name} is currently ${line.isDisabled ? 'disabled' : 'active'}. `
      + `Would you like to ${line.isDisabled ? 'activate' : 'disable'} it?`;
    let subject = `${line.isDisabled ? 'Activate' : 'Disable'} Line ${line.name}?`;

    this.uiUtilityService.confirm(message, subject, 'Yes', 'No').then(confirmed => {
      if (!confirmed) {
        return;
      }

      let promise = this.lineConfigsService.toggleLine({
        id: line.id,
        shopId: line.shopId,
        isDisabled: !line.isDisabled
      }).then(() => line.isDisabled = !line.isDisabled);

      this.loaderService.loadingPromise(promise);
    });
  }

  viewGroupRejectDetail(equipmentGroup: LineEquipmentGroup) {
    // console.log("equipmentGroup", equipmentGroup);
    this.model.currentGroup = equipmentGroup;
    this.groupRejectsService.showGroupRejects({
      equipmentGroup: equipmentGroup,
      shopId: this.shop.id,
      lineCounts: this.model,
      countsInterval: this.countsInterval
    });
  }

  toggleHelpWindow = (): void => {
		this.showHelpWindow = !this.showHelpWindow;
	}

  showHelp(helpScreen: string)
  {
    console.log(helpScreen);
    this.helpText = getCountsHelpText(helpScreen);
		this.toggleHelpWindow();
  }

  getDetailsChartConfig() {
    return {
      chart: {
        alignTicks: true,
        zoomType: 'xy',
        styleMode: true,
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      xAxis: {
        categories: ['', '', '', ''],
        labels: {
          enabled: false
        }
      },
      yAxis: {
        title: {
          text: null
        },
        labels: {
          enabled: true
        },
        allowDecimals: false
      },
      plotOptions: {
        series: {
          marker: {
            enabled: true
          },
          animation: false
        }
      },
      tooltip: {
        useHtml: true,
        pointFormat: '<b>{point.y}</b>',
      },
      series: [{
        type: 'spline',
        data: [],
        color: '#919391',
        name: ''
      }]
    };
  }

  getLossPercentClass(equipment): string {
    if(!equipment) { return ''; }
    let rejectTolerance = this.equipmentRejectTolerances[equipment.name];
    if(!equipment.rejectCount || !rejectTolerance) { 
      return '';
    }
    if(this.isRejectPercentWithinTolerance(equipment, rejectTolerance)) {
      let percentageClass = '';
      if(equipment.rejectCount.percent.error) {
        percentageClass = 'vc-bg-warning '
      }
        percentageClass += 'text-danger';
        return percentageClass;
    }
    return '';
  }

	getEquipmentClass(equip: any): string {
    equip = equip[0];
    if(!equip) { return ''; }
    if(equip.isDisabled) { return 'equipment-disabled'; }
    
    let rejectTolerance = this.equipmentRejectTolerances[equip.name];

		var equipmentClass = '';
    if(equip.rejectCount && !!rejectTolerance  &&
      this.isRejectPercentWithinTolerance(equip, rejectTolerance)) {
			equipmentClass = 'rejectBgVerticals';
			if(this.countsInterval == apsDisplayEnums.CountDisplayInterval.CurrentHour
				|| this.countsInterval == apsDisplayEnums.CountDisplayInterval.CurrentShift
				|| this.countsInterval == apsDisplayEnums.CountDisplayInterval.RollingHour
				|| this.countsInterval == apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes) {
				equipmentClass =  this.blinkClass;
			}
		}
		return equipmentClass;
	}

  getRowClass(equipment): string {
    let rejectTolerance = this.equipmentRejectTolerances[equipment.name];
    if(!equipment.rejectCount || !rejectTolerance) { 
      return '';
    }
    if(this.isRejectPercentWithinTolerance(equipment, rejectTolerance)) {
      return 'rejectEquipVerticals';
    }
  }

  isRejectPercentWithinTolerance(equipment: VertCtEquipment | LineEquipmentItem, tolerance: RejectTolerances): boolean {
    let rejectPercentage = equipment.rejectCount.percent;

    if(angular.isString(rejectPercentage)){
      return Number(rejectPercentage) > tolerance.rejectMaxPercentage
          || Number(rejectPercentage) < tolerance.rejectMinPercentage;
    }
    else {
      return Number(rejectPercentage.value.replace("%","")) > tolerance.rejectMaxPercentage
          || Number(rejectPercentage.value.replace("%","")) < tolerance.rejectMinPercentage;
    }
  }

  countsIntervalChanged() {
    this.update();
  }

  viewDetails(count: any, type: string) {
    this.$scope.count = count;
  }

  dateRange() {
    return {
      dataPointId: null,
      countInterval: apsEnums.CountInterval.TenMinutes,
      start: () => moment().subtract(2, 'hour').toDate(),
      end: () => moment().toDate()
    };
  }

  createGetDataPointIdRequestForParent(id, startDate, endDate, countInterval, eq) {
    var rq = {
      dataPointId: id,
      start: startDate,
      end: endDate,
      countInterval: countInterval,
      type: "parent",
      eq: eq
    } as VertCtDataPointHistoryRequest;
    var dp = new VertCtDataPointHistoryReportItem();
    dp.request = rq;
    let promise = this.countsService.getByDatapointId(
      rq.dataPointId,
      rq.start,
      rq.end,
      rq.countInterval.toString())
      .then((response) => {
        dp.result = response.map((x) => x.value);
        this.parents.dataPoints.push(dp);
      });
    return promise;
  }

  createGetDataPointIdRequestForChild(plantLocationId: string, shopId: string, ids: string[], startDate: Date, endDate: Date, countInterval: apsEnums.CountInterval, eq: VertCtEquipment) {

    // create a request object
    var rq = {
      plantLocationId: plantLocationId, // todo : get plantlocationId
      shopId: shopId, // todo : get shop
      datapointIds: ids,
      startDate: startDate,
      endDate: endDate,
      countInterval: countInterval,
      type: "child",
      eq: eq
    } as VertCtDatapointListRequest;

    // create a container for the request
    var dp = new VertCtDatapointListReportItem();
    dp.request = rq;

    // create request promise
    let promise = this.countsService.getByDatapointList(
      rq.plantLocationId,
      rq.shopId,
      rq.datapointIds,
      rq.startDate,
      rq.endDate,
      rq.countInterval.toString())
      .then((response) => {
        var trendCounts = response.map((x) => x.value);
        rq.eq.rejectCount.trendCounts = trendCounts;
        dp.result = trendCounts;
      });

    return promise;
  }

  getChildrenTrendCounts(): IPromise<any> {
    console.log('child trend counts started...');

    // create promises collection
    const promises = [];

    // get date ranges for last 2 hours
    var startDate = moment().subtract(2, 'hour').toDate();
    var endDate = moment().toDate();
    var countInterval = apsEnums.CountInterval.TenMinutes;

    _.forEach(this.vc, (ct) => {
      _.forEach(ct.children, child => {
        _.forEach(child.equipment, eq => {
          if (angular.isDefined(eq.id)) {
            const promise = this.createGetDataPointIdRequestForChild(this.plant.id, this.shop.id, [], startDate, endDate, countInterval, eq);
            promises.push(promise);
          } // endif
        });
      }); // foreach
    }); // foreach

    return this.$q.all(promises).then(() => {
      _.forEach(this.children.dataPoints, (dp) => {
        var i = this.children.hash[dp.request.dataPointId];
        if (angular.isDefined(i)) {
          i.rejectCount.trendCounts = dp.result;
        }
      });
      console.log("child trend counts completed.", this.children);
    }).catch(response => {
      console.log(response);
    });
  }

  getParentTrendCounts(): IPromise<any> {

    console.log('parent trend counts started...');

    // create promises collection
    const promises = [];

    // get date ranges for last 2 hours
    var startDate = moment().subtract(2, 'hour').toDate();
    var endDate = moment().toDate();
    var countInterval = apsEnums.CountInterval.TenMinutes;

    _.forEach(this.vc, (ct) => {
      _.forEach(ct.equipment, (eq) => {
        if (angular.isDefined(eq.rejectCount) && angular.isDefined(eq.rejectCount.id) && eq.rejectCount.id != "") {
          const promise = this.createGetDataPointIdRequestForParent(eq.rejectCount.id, startDate, endDate, countInterval, eq);
          promises.push(promise);
        }
      }); // foreach
    }); // foreach

    return this.$q.all(promises).then(() => {
      _.forEach(this.parents.dataPoints, (dp) => {
        var i = this.parents.hash[dp.request.dataPointId];
        if (angular.isDefined(i)) {
          i.rejectCount.trendCounts = dp.result;
        }
      });
      console.log("parent trend counts completed.", this.parents);
    }).catch(response => {
      console.log(response);
    });
  } // end getTrendCounts
}

const sortDate = (a: Date, b: Date) => {
  return b.valueOf() - a.valueOf();
};

const fmt = (x: Date) => moment(x).format("L LT");

const detailChartv2 = function () {
  return {
    restrict: 'E',
    template: '<div></div>',
    scope: {
      options: '='
    },
    link: function (scope, element, attributes) {

      // Wait until finished loading, so that the dynamic id's will be ready
      angular.element(document).ready(function () {

        // Load any charts with data (first time)
        try {
          const jsonData = JSON.parse(attributes.data);
          if (attributes.data !== null && jsonData.length > 1 && attributes.data !== '[0,0,0,0]') {
            scope.options.series[0].data = jsonData;
            const chart = new Highcharts.Chart(element[0], scope.options);
          }
        } catch (e) {
          return false;
        }

        // watch the data attribute and if it changes, update the chart series
        scope.$watch(function () {
          return element.attr('data');
        }, function (newValue) {
          try {
            const jsonData = JSON.parse(attributes.data);
            if (newValue !== null && jsonData.length > 1 && newValue !== '[0,0,0,0]') {
              scope.options.series[0].data = jsonData;
              const chart = new Highcharts.Chart(element[0], scope.options);
            }
          } catch (e) {
            return false;
          }
        });
      });
    }
  };
};

export interface ICountVerticalController {
  $stateParams: StateParams;
  $state: angular.ui.IStateService;
  interval: IInterval;
  model: LineCounts;
  areas: CountArea[];
  plant: Plant;
  shop: apsViewModels.ShopNavigation;
  hub: CountHub;
  updatedModel: LineCounts;
  updatedAreas: CountArea[];
  countDisplayIntervalOptions: EnumOption[];
  countsInterval: apsDisplayEnums.CountDisplayInterval;
  canDisableLine: boolean;
  cavities: apsViewModels.CavityCountSummary[];
  hasCavities: boolean;
  detailChartConfig: any;
  showCharts: boolean;
  navigationUrls: IBtnArrayOptions;
  viewRejectDetail(line: LineItem, equipment: LineEquipmentItem): void;
  viewGroupRejectDetail(equipmentGroup: LineEquipmentGroup): void;
  countsIntervalChanged(): void;
  calculateSpeed(gobsCount: Counts): number;
  toggleLineActive(line: LineItem): void;
  showHelp(helpScreen: string): void;
  toggleHelpWindow(): void;
	showHelpWindow: boolean;
	helpText: string;
  requests: object;
  vc: Array<any>;
}

export interface CountRow {
  isLine: boolean;
  line: LineItem;
  junction: LineJunctionItem;
  cssClass: string;
}

export interface CountArea {
  rows: CountRow[];
}

const countsConfig = function ($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state({
    name: States.COUNTS_VERTICAL_V2,
    url: '/countsverticalv2',
    controller: 'CountsVerticalCtrlV2 as vm',
    template: template,
    data: {
      pageTitle: 'Vertical Counts',
      authorizeAPSIOAdmin: true
    }
  });
};

export default angular.module('aps.controller.countsVerticalv2', requires)
  .config(countsConfig)
  .controller('CountsVerticalCtrlV2', CountsVerticalCtrlV2)
  .directive('detailChartv2', detailChartv2)
  .directive('sparklineChartV2', sparklineChartV2)
  .name;

  function getCountsHelpText(helpScreen: string): string {
    let helptext = '';
  
    switch (helpScreen) {
      case 'EQUIPMENT COUNTS':
        helptext = `  
        <div class="header">
          Equipment Counts
        </div>         
        <div class="subheader">
          <u>How the Counts Work</u>:
        </div>
        <div class="detail">
          Below is a sample count object, this is sample data just for instructional purposes.
        </div>
        <div class="counts-equipment-details">
          <div class="row-flex">
            <div class="bs-col-3">
              <div class="vc-col cur-ptr">
                <span class="bs-text-nowrap count" title="809b0000-ff45-0003-8918-08d563f1a496">SQR</span>
              </div>
            </div>
            <div class="bs-col-9 no-margin">
              <div class="vc-col"  class="borderclass">
                <div class="cur-ptr eq-box">
                <table cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <td>
                        <div class="eq-col eq-idx">
                          <span>H</span>
                        </div>
                      </td>
                      <td>
                        <div class="eq-col eq-ict">
                          <span>6,447</span>
                        </div>
                      </td>

                      <td>
                        <div class="eq-col eq-sparkline">
                            <span class="ng-binding">258</span>
                            <i class="vc-trend fa  fa-angle-down" ng-class="{'fa-angle-up': equipment.rejectCount.trend.up, 'fa-angle-down': equipment.rejectCount.trend.down}"></i>
                        </div>
                      </td>
                      <td>
                        <div class="eq-col eq-rpt">
                            <b>4.00%</b> &nbsp;
                        </div>
                      </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail">
          As you can see the count object is broken up into 4 different columns. Here is the definition of each columns:
        </div>  
        <div class="detail">
          <ol type = "1">
            <li class="detail">
              <b>Equipment Shorthand:</b> This is a shorthand abreviation of the type of equipment configured on the line.
              In this case this is a high speed squeezer. This is abreviated as SQR.
            </li>
            <li class="detail">
              <b>Inspect Count:</b> The number of bottles going into the machine.
              In APS the preference is to use a direct integration to the machine for this counter.
              However, there are instances that we are dependent on a photoeye before the inspection equipment 
              to provide the inspect count.
            </li>
            <li class="detail">
              <b>Reject Count:</b>
              The amount of bottles rejected by the piece of inspection equipment.
              However, for some equipment integrations we need to calculated it by taking the difference between
              bottles in and bottles out.
              <br/>
              <span class="formula">Reject Count = Reject Count from Machine</span><br/>
              <span class="footnote">[where machine has direct integration]</span><br/>
              <span class="formula">Reject Count = Machine Bottles In - Machine Bottles Out</span><br/>
              <span class="footnote">[where machine only has input/output]</span><br/>
            </li>
            <li class="detail">
              <b>Reject Percent:</b>
              The percent of loss for each piece of equipment.
              This calculation is based off the equipment inspects vs. the rejects.
              <br/>
              <span class="formula">Reject Percent = Reject Count / Inspect Count</span><br/>

              On each job run, an acceptable percentage range can be set for each equipment type. If the equipment has a tolerance set
              and the current value is outside those parameters, this value is highlighted in 
              <span class="red">red</span> to help users quickly identify issues.
            </li>
          </ol>
        </div>
        <div class="subheader">
          <u>Equipment Details</u>:
        </div>   
        <div class="detail">
          On some equipment, there is detail data listed under the summary row.
          Depending on the type of integration some equipment will display more data than others.
        </div>
          `;
        break;
      case 'EQUIPMENT GROUP':
        helptext = `  
        <div class="header">
          EQUIPMENT COUNTS by CATEGORY (% of SHEARS)
        </div>         
        <div class="subheader">
          <u>Metrics per Category</u>:
        </div>
        <div class="detail">
          This metric measures the total losses by equipment type against shear cuts.
          The metric definitions are as follows.
        </div>
        <div class="detail">
          <ol type = "1">
            <li class="detail">
            <b>INSPECTS:</b> The total number of bottles going into each equipment category.
            </li>
            <li class="detail">
              <b>REJECTS:</b> 
              The total amount of bottles rejected in each equipment category.
            </li>
            <li class="detail">
              <b>REJECT %:</b>
              The percent loss for each equipment category.
              On each job run, an acceptable percentage range can be set for each equipment type. If the equipment has a tolerance set
              and the current value is outside those parameters, this value is highlighted in 
              <span class="red">red</span> to help users quickly identify issues.
              <br/>
              <span class="formula">REJECT % = 100 * (Rejects by Category/ Shears)</span>
            </li>
          </ol>
        </div>
          `;
        break;
      case 'SHOP KPI':
        helptext = `  
        <div class="header">
          Shop KPI's
        </div>         
        <div class="subheader">
          <u>KPI Metric Definitions</u>:
        </div>
        <div class="detail">
          The goal of these KPI's is to see how the shop is performing at each point along the line.
          We use each pulse from the shear cuts to calculate how many gobs are currently being produced.
        </div>
        <div class="detail">
          <ol type = "1">
            <li class="detail">
              <b>MACHINE SPEED:</b>
              How many bottles per minute the machine is producing.
              When available we use direct machine integration.
              Otherwise, we use the shear pulses to estimate the speed.
            </li>
            <li class="detail">
              <b>H/E Efficiency:</b> 
              The percent of bottles going into the lehr, against the shears.
              <br/>
              <span class="formula">H/E Efficiency = Lehr In Counter / Shears</span>
            </li>
            <li class="detail">
              <b>C/E Efficiency:</b>
              The percent of bottles that make it to the End of Line (EOL), compared to the lehr. 
              This is usually a photoeye, sometimes it can be the last piece of inspection equipment. It depends on the shop configuration.
              <br/>
              <span class="formula">C/E Efficiency = EOL / Lehr In Counter</span>
            </li>
            <li class="detail">
              <b>Pack Efficiency:</b>
              The percent of bottles that make it to the End of Line (EOL), against the shears. 
              This is usually a photoeye, sometimes it can be the last piece of inspection equipment. It depends on the shop configuration.
              <br/>
              <span class="formula">Pack Efficiency = EOL / Shears</span>
            </li>
          </ol>
        </div>
          `;
        break;
    
      default:
        helptext = 'Selected Help Screen Not Found...';
        break;
    }
  
    return helptext;
  }


// WEBPACK FOOTER //
// ./src/app/controllers/counts/countVerticalv2.controller.ts